var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{staticClass:"r-chip q-py-xs cursor-pointer",class:[
    _vm.active
      ? 'q-pl-sm q-pr-md text-body-3 text-white-1 bg-graph-certain text-capitalize'
      : 'bg-white-3 text-body-1 text-grey3 q-px-md q-py-sm'
  ],attrs:{"gaf":"column","gap":"var(--r-space-xs)","align-items":"center"},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[(_vm.active)?_c('DoneIcon',{staticClass:"done-icon",attrs:{"dense":""}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }